var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.company_dtls") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          this.$engine.company.redirection === "0"
            ? _c(
                "b-row",
                { staticClass: "pb-3 mx-0" },
                [
                  _c("back-button", {
                    staticClass: "btnFilter_2",
                    attrs: { returnUrl: _vm.returnUrl },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-xl-start mb-1" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                xl: "9",
                                lg: "12",
                                md: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "b-button-group",
                                { staticClass: "mt-3 mt-sm-0" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 0
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 0
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.remittance_generation.global"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 1
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 1
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.remittance_generation.habilitation"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 2
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 2
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.remittance_generation.parameter"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-2" }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      staticClass: "mt-3",
                      attrs: { "nav-class": "d-none" },
                      model: {
                        value: _vm.tabName,
                        callback: function ($$v) {
                          _vm.tabName = $$v
                        },
                        expression: "tabName",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        [
                          _vm.CompaniesList.length > 0
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "title-label-blue w-200px mb-n1px pt-3",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("administration.company_info")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("table", { staticClass: "table" }, [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("mandate.parent_node")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.CompaniesList[0].account
                                                  .name_parent
                                                  ? _vm.CompaniesList[0].account
                                                      .name_parent
                                                  : "-"
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "administration.company_id"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account
                                                .identifier
                                                ? _vm.CompaniesList[0].account
                                                    .identifier
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "administration.company_name"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account.name
                                                ? _vm.CompaniesList[0].account
                                                    .name
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "administration.company_email"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account
                                                .email_reference
                                                ? _vm.CompaniesList[0].account
                                                    .email_reference
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("administration.active")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm.CompaniesList[0].active == 0
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-duotone fa-xmark btn-icon text-danger p-0",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.CompaniesList[0].active == 2
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-duotone fa-check btn btn-icon text-success p-0",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.CompaniesList[0].active == 1
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-duotone fa-warning btn btn-icon text-warning p-0",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("administration.address")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account
                                                .address
                                                ? _vm.CompaniesList[0].account
                                                    .address
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("administration.city")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account.city
                                                ? _vm.CompaniesList[0].account
                                                    .city
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("administration.zip_code")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account
                                                .zip_code
                                                ? _vm.CompaniesList[0].account
                                                    .zip_code
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("administration.country")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-center w-50" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.CompaniesList[0].account
                                                .country
                                                ? _vm.CompaniesList[0].account
                                                    .country
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "min-w-100 align-items-center" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _vm.canCompanyDelete || _vm.canCompanyEdit
                                    ? [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "back-button btnFilter_2 mr-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.activateCompanyEdit(
                                                  _vm.CompaniesList[0].idCompany
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa-light fa-pencil",
                                            }),
                                            _vm._v(
                                              "  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.company_edit"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "back-button btnFilter_2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.activateCompanyDelete(
                                                  _vm.CompaniesList[0].idCompany
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-trash",
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.company_delete"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "title-label-blue w-200px mb-n1px pt-3",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("mandate.technical_access.title")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("table", { staticClass: "table" }, [
                              _c("tbody", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    { staticClass: "text-center w-50" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.technical_access.technical_user_id"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-center w-50" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.technicalUserLogin || "-")
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: { disabled: !_vm.isEditable },
                                model: {
                                  value: _vm.technicalUser,
                                  callback: function ($$v) {
                                    _vm.technicalUser = $$v
                                  },
                                  expression: "technicalUser",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "mandate.technical_access.technical_user_mode"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-container",
                              { attrs: { fluid: "" } },
                              [
                                _c("certificate-form-global", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.technicalUser,
                                      expression: "technicalUser",
                                    },
                                  ],
                                  ref: "keystoreFormGlobal",
                                  attrs: {
                                    "technical-user": _vm.technicalUser,
                                    mode: _vm.formType,
                                    id: _vm.id,
                                    "id-certificate": _vm.idCertificate,
                                    "id-private-key": _vm.idPrivateKey,
                                    "id-company": _vm.idCompany,
                                    "id-user-api": _vm.idUserApi,
                                    "id-rights-profile-api":
                                      _vm.idRightsProfileApi,
                                    "name-company": _vm.nameCompany,
                                    readonly: !_vm.isEditable,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "d-flex justify-content-end" },
                            [
                              _c(
                                "div",
                                [
                                  this.isEditable && this.formType !== "add"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "back-button btnFilter_2 mr-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.switchMode("view")
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.cncl"))
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  !this.isEditable
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "back-button btnFilter_2 mr-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.switchMode("edit")
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("administration.edit")
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.isEditable && this.formType !== "add"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "back-button btnFilter_2 mr-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveKeystore()
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.sve"))
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "title-label-blue w-200px pt-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_users"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("table", { staticClass: "table" }, [
                            _c("thead", [
                              _c("th", { staticClass: "text-center w-200px" }, [
                                _vm._v(
                                  "\n                  Login\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-center w-200px" }, [
                                _vm._v(
                                  "\n                  Name\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm.filteredUsers.length > 0
                                  ? _vm._l(
                                      _vm.filteredUsers,
                                      function (result) {
                                        return _c(
                                          "tr",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDetailsUser(
                                                  result
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [_vm._v(_vm._s(result.login))]
                                            ),
                                            _vm._v(" "),
                                            !result.name
                                              ? _c("td", [_vm._v("-")])
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "cursor text-ellipsis",
                                                  },
                                                  [_vm._v(_vm._s(result.name))]
                                                ),
                                          ]
                                        )
                                      }
                                    )
                                  : _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "noResult",
                                          attrs: { colspan: "6" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("common.no_result")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.canAddUser
                            ? _c(
                                "b-row",
                                {
                                  staticClass:
                                    "no-gutter d-flex justify-content-end",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "back-button btnFilter_2",
                                      on: { click: _vm.addUser },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-plus",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("administration.user_add")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "title-label-blue w-200px pt-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_prfls"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("table", { staticClass: "table" }, [
                            _c("thead", [
                              _c("th", { staticClass: "text-center w-200px" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("administration.label")) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm.filteredProfiles.length
                                  ? _vm._l(
                                      _vm.filteredProfiles,
                                      function (result) {
                                        return _c(
                                          "tr",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDetailsProfile(
                                                  result
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "text-center",
                                                attrs: {
                                                  title: result.libelle,
                                                },
                                              },
                                              [_vm._v(_vm._s(result.libelle))]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  : _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "noResult",
                                          attrs: { colspan: "6" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("common.no_result")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.canAddRole
                            ? _c(
                                "b-row",
                                {
                                  staticClass:
                                    "no-gutter d-flex justify-content-end",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "back-button btnFilter_2",
                                      on: { click: _vm.addRole },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-plus",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("administration.profile_add")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "title-label-blue w-200px pt-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_rights"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("table", { staticClass: "table text-center" }, [
                            _c("thead", [
                              _c("th", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("administration.right_list")
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm.CompaniesList.length > 0
                                  ? _vm._l(
                                      _vm.CompaniesList[0].rights,
                                      function (result) {
                                        return _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t(
                                                    "rights.db_rights." + result
                                                  ) ===
                                                  "rights.db_rights." + result
                                                    ? result
                                                    : _vm.$t(
                                                        "rights.db_rights." +
                                                          result
                                                      ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "rights.db_rights." +
                                                        result
                                                    ) ===
                                                      "rights.db_rights." +
                                                        result
                                                      ? result
                                                      : _vm.$t(
                                                          "rights.db_rights." +
                                                            result
                                                        )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    )
                                  : _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "noResult",
                                          attrs: { colspan: "6" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("common.no_result")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                              ],
                              2
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                open: "",
                                title: _vm.$t(
                                  "mandate.remittance_generation.sdd_remittance_generation"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "sdd-generation-settings" },
                                [
                                  _c("div", { staticClass: "generation-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationMode,
                                              expression: "generationMode",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "generationManual",
                                            type: "radio",
                                            name: "generationRadio",
                                            value: "manual",
                                            disabled: !_vm.doesEdit,
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.generationMode,
                                              "manual"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.generationMode = "manual"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: { for: "generationManual" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.manual_trigger"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "generation-row interval-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-radio",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.generationMode,
                                                expression: "generationMode",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              id: "generationInterval",
                                              type: "radio",
                                              name: "generationRadio",
                                              value: "auto",
                                              disabled: !_vm.doesEdit,
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.generationMode,
                                                "auto"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.generationMode = "auto"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: "generationInterval",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.within_interval"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "interval-selects" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.generationFrequency,
                                                  expression:
                                                    "generationFrequency",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.generationMode !== "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.generationFrequency =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "daily" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.daily"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "weekly" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.weekly"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.generationTime,
                                                  expression: "generationTime",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm space",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.generationMode !== "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.generationTime = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            _vm._l(24, function (hour) {
                                              return _c(
                                                "option",
                                                {
                                                  key: hour - 1,
                                                  domProps: {
                                                    value:
                                                      String(hour - 1).padStart(
                                                        2,
                                                        "0"
                                                      ) +
                                                      "-" +
                                                      String(
                                                        hour % 24
                                                      ).padStart(2, "0"),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(hour - 1) +
                                                      "h - " +
                                                      _vm._s(hour % 24) +
                                                      "h\n                      "
                                                  ),
                                                ]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                open: "",
                                title: _vm.$t(
                                  "mandate.remittance_generation.sdd_remittance_file_generation"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "sdd-generation-settings" },
                                [
                                  _c("div", { staticClass: "generation-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationModeSDD,
                                              expression: "generationModeSDD",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "sddgenerationManual",
                                            type: "radio",
                                            name: "sddgenerationRadio",
                                            value: "manual",
                                            disabled: !_vm.doesEdit,
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.generationModeSDD,
                                              "manual"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.generationModeSDD = "manual"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: {
                                              for: "sddgenerationManual",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.manual_trigger"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "generation-row interval-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-radio",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.generationModeSDD,
                                                expression: "generationModeSDD",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              id: "sddgenerationInterval",
                                              type: "radio",
                                              name: "sddgenerationRadio",
                                              value: "auto",
                                              disabled: !_vm.doesEdit,
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.generationModeSDD,
                                                "auto"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.generationModeSDD = "auto"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: "sddgenerationInterval",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.within_interval"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "interval-selects" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.generationFrequencySDD,
                                                  expression:
                                                    "generationFrequencySDD",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.generationModeSDD !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.generationFrequencySDD =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "daily" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.daily"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "weekly" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.weekly"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.generationTimeSDD,
                                                  expression:
                                                    "generationTimeSDD",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm space",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.generationModeSDD !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.generationTimeSDD = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            _vm._l(24, function (hour) {
                                              return _c(
                                                "option",
                                                {
                                                  key: "sdd-" + (hour - 1),
                                                  domProps: {
                                                    value:
                                                      String(hour - 1).padStart(
                                                        2,
                                                        "0"
                                                      ) +
                                                      "-" +
                                                      String(
                                                        hour % 24
                                                      ).padStart(2, "0"),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(hour - 1) +
                                                      "h - " +
                                                      _vm._s(hour % 24) +
                                                      "h\n                      "
                                                  ),
                                                ]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                open: "",
                                title: _vm.$t(
                                  "mandate.remittance_generation.sct_remittance_generation"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "sct-generation-settings" },
                                [
                                  _c("div", { staticClass: "generation-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sctGenerationMode,
                                              expression: "sctGenerationMode",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "sctGenerationManual",
                                            type: "radio",
                                            name: "sctGenerationRadio",
                                            value: "manual",
                                            disabled: !_vm.doesEdit,
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.sctGenerationMode,
                                              "manual"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.sctGenerationMode = "manual"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: {
                                              for: "sctGenerationManual",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.manual_trigger"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "generation-row interval-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-radio",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.sctGenerationMode,
                                                expression: "sctGenerationMode",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              id: "sctGenerationInterval",
                                              type: "radio",
                                              name: "sctGenerationRadio",
                                              value: "auto",
                                              disabled: !_vm.doesEdit,
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.sctGenerationMode,
                                                "auto"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.sctGenerationMode = "auto"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: "sctGenerationInterval",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.within_interval"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "interval-selects" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.sctGenerationFrequency,
                                                  expression:
                                                    "sctGenerationFrequency",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.sctGenerationMode !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.sctGenerationFrequency =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "daily" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.daily"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "weekly" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.weekly"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.sctGenerationTime,
                                                  expression:
                                                    "sctGenerationTime",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm space",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.sctGenerationMode !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.sctGenerationTime = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            _vm._l(24, function (hour) {
                                              return _c(
                                                "option",
                                                {
                                                  key:
                                                    "sct-generation-" +
                                                    (hour - 1),
                                                  domProps: {
                                                    value:
                                                      String(hour - 1).padStart(
                                                        2,
                                                        "0"
                                                      ) +
                                                      "-" +
                                                      String(
                                                        hour % 24
                                                      ).padStart(2, "0"),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(hour - 1) +
                                                      "h - " +
                                                      _vm._s(hour % 24) +
                                                      "h\n                      "
                                                  ),
                                                ]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                open: "",
                                title: _vm.$t(
                                  "mandate.remittance_generation.sct_remittance_file_generation"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "sct-file-generation-settings" },
                                [
                                  _c("div", { staticClass: "generation-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sctFileGenerationMode,
                                              expression:
                                                "sctFileGenerationMode",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "sctFileGenerationManual",
                                            type: "radio",
                                            name: "sctFileGenerationRadio",
                                            value: "manual",
                                            disabled: !_vm.doesEdit,
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.sctFileGenerationMode,
                                              "manual"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.sctFileGenerationMode =
                                                "manual"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: {
                                              for: "sctFileGenerationManual",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.manual_trigger"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "generation-row interval-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-radio",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.sctFileGenerationMode,
                                                expression:
                                                  "sctFileGenerationMode",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              id: "sctFileGenerationInterval",
                                              type: "radio",
                                              name: "sctFileGenerationRadio",
                                              value: "auto",
                                              disabled: !_vm.doesEdit,
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.sctFileGenerationMode,
                                                "auto"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.sctFileGenerationMode =
                                                  "auto"
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: "sctFileGenerationInterval",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.within_interval"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "interval-selects" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.sctFileGenerationFrequency,
                                                  expression:
                                                    "sctFileGenerationFrequency",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.sctFileGenerationMode !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.sctFileGenerationFrequency =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "daily" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.daily"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "weekly" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.remittance_generation.weekly"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.sctFileGenerationTime,
                                                  expression:
                                                    "sctFileGenerationTime",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm space",
                                              attrs: {
                                                disabled:
                                                  !_vm.doesEdit ||
                                                  _vm.sctFileGenerationMode !==
                                                    "auto",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.sctFileGenerationTime =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            _vm._l(24, function (hour) {
                                              return _c(
                                                "option",
                                                {
                                                  key:
                                                    "sct-file-generation-" +
                                                    (hour - 1),
                                                  domProps: {
                                                    value:
                                                      String(hour - 1).padStart(
                                                        2,
                                                        "0"
                                                      ) +
                                                      "-" +
                                                      String(
                                                        hour % 24
                                                      ).padStart(2, "0"),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(hour - 1) +
                                                      "h - " +
                                                      _vm._s(hour % 24) +
                                                      "h\n                      "
                                                  ),
                                                ]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                open: "",
                                title: _vm.$t(
                                  "mandate.remittance_generation.expiring_extraction"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "expiring-mandates-settings" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "generation-row interval-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-radio",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "expiringMandatesType",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.type"
                                                    )
                                                  ) +
                                                  "\n      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "interval-selects-type",
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.expiringMandatesType,
                                                  expression:
                                                    "expiringMandatesType",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                id: "expiringMandatesType",
                                                disabled: !_vm.doesEdit,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.expiringMandatesType =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "manual" } },
                                                [
                                                  _vm._v(
                                                    "\n          " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.remittance_generation.none"
                                                        )
                                                      ) +
                                                      "\n        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "ftp" } },
                                                [
                                                  _vm._v(
                                                    "\n          " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.remittance_generation.ftp"
                                                        )
                                                      ) +
                                                      "\n        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          true
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass: "d-flex justify-content-end",
                                    },
                                    [
                                      _vm.doesEdit
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "back-button btnFilter_2 mr-2",
                                                  on: {
                                                    click: _vm.resetSettings,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.cncl")
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          !_vm.doesEdit
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "back-button btnFilter_2 mr-2",
                                                  on: {
                                                    click: _vm.editSettings,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "administration.edit"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.doesEdit
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "back-button btnFilter_2 mr-2",
                                                  on: {
                                                    click: _vm.updateSettings,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.update")
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }